(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var tiles = document.querySelectorAll('.tile-showcase__tile');

  if (tiles.length) {
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      tiles.forEach(function (tile) {
        tile.classList.add('is-visible');
      });
    } else {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.35 }
      );

      tiles.forEach(function (tile) {
        observer.observe(tile);
      });
    }
  }

  // Mobile carousel: keep the dot indicators in sync with scroll position
  document.querySelectorAll('.tile-showcase__grid').forEach(function (grid) {
    var section = grid.closest('.tile-showcase');
    var dots = section ? section.querySelectorAll('.tile-showcase__dot') : [];
    if (!dots.length) return;

    var gridTiles = grid.querySelectorAll('.tile-showcase__tile');

    function updateActiveDot() {
      var gridRect = grid.getBoundingClientRect();
      var closestIndex = 0;
      var closestDistance = Infinity;

      gridTiles.forEach(function (tile, index) {
        var tileRect = tile.getBoundingClientRect();
        var distance = Math.abs(tileRect.left - gridRect.left);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === closestIndex);
      });
    }

    var ticking = false;
    grid.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateActiveDot();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', updateActiveDot);
    updateActiveDot();
  });
})();
